import React, { Suspense, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
// import Mainnav from "../../Common/Components/Mainnav";
import ContentInner from "./Contentinner.tsx";
import EmailBrowser from "../../EmailBrowser/EmailBrowser";
import ArticlePreviewSidebar from "./ArticlePreviewSidebar";

import { CustomDragLayer } from "modules/Common/Components/CustomDragLayer";
import CampaignWrapperInner from "modules/Campaigns/Shared/CampaignWrapperInner";
import AudienceWrapper from "modules/Campaigns/Audience/Components/AudienceWrapper";
import { AnalyticsWrapper } from "modules/Analytics/Components/AnalyticsWrapper";
import { getUserData } from "modules/Login/action";
import AutomationWrapper from "modules/Automation/Shared/AutomationWrapper";
import ManageWrapper from "modules/Manage/Shared/ManageWrapper";

const Mainnav = React.lazy(() => import("../../Common/Components/Mainnav"));

const Content = (props) => {
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    getUserData();
  }, []);
  return (
    <>
      {/* <DndProvider backend={HTML5Backend}> */}
      <Wrapper>
        <Suspense fallback={<></>}>
          <Mainnav />
        </Suspense>
        <div className="content-inner">
          {path.startsWith("/content") ? (
            <ContentInner tab={props.match.params.tab} />
          ) : path.startsWith("/campaigns") ? (
            <CampaignWrapperInner
              page={props.match.params.page}
              tab={props.match.params.tab}
              subTab={props.match.params.subTab}
            />
          ) : path.startsWith("/audiences") ? (
            <AudienceWrapper
              page={props.match.params.page}
              tab={props.match.params.tab}
              subTab={props.match.params.subTab}
            />
          ) : path.startsWith("/analytics") ? (
            <AnalyticsWrapper page={props.match.params.page} tab={props.match.params.tab} />
          ) : path.startsWith("/automation") ? (
            <AutomationWrapper page={props.match.params.page} tab={props.match.params.tab} />
            //* Uncomment the following to include Custom Widget Groups
          ) : path.startsWith("/groups") ? (
            <ManageWrapper page={props.match.params.page} tab={props.match.params.tab} />
          ) : null}
          <CustomDragLayer />
          {path.startsWith("/audiences") ? null : path.startsWith("/content") ||
            props.match.params.tab === "source" ||
            props.match.params.tab === "favorites" ? (
            <EmailBrowser />
          ) : null}
          <ArticlePreviewSidebar />
        </div>
      </Wrapper>
    </>
  );
};

export default Content;

const Wrapper = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .content-inner {
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    background-color: #f9f8f6;
    box-sizing: border-box;
    width: calc(100% - 88px);
    float: right;
    min-height: 100vh;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
    }
  }
`;
